import Grid from '@material-ui/core/Grid'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import Button from './Button'

const useStyle = makeStyles({
  root: {
    background: '#ffffff',
  },
  container: {
    paddingTop: 48,
    paddingBottom: 48,
    lineHeight: '32px',
  },
  bigText: {
    fontSize: 24,
    fontWeight: 'bold',
  },
})

const HelpBlock = () => {
  const classes = useStyle()

  return (
    <div className={classes.root}>
      <Container maxWidth={'lg'} className={classes.container}>
        <Grid container alignItems={'center'} justifyContent={'center'}>
          <Grid item xs={12} md={4}>
            <div className={classes.bigText}>
              <FormattedMessage
                id={'HelpBlock.NeedHelp'}
                defaultMessage={"Une question ? Besoin d'aide ?"}
              />
            </div>
          </Grid>

          <Grid item xs={12} md={5}>
            <FormattedMessage
              id={'HelpBlock.goToCenter'}
              defaultMessage={'Consultez notre aide en ligne ou contactez nous'}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <a href={'https://aide.callalawyer.fr/'} target={'_blank'}>
              <Button color={'secondary'} size={'large'} variant={'contained'} fullWidth>
                <InfoOutlinedIcon />
                   
                <FormattedMessage
                  id={'HelpBlock.CTA'}
                  defaultMessage={"Consulter le centre d'aide"}
                />{' '}
              </Button>
            </a>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default HelpBlock
